var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/inherits");

var Gateway = require('./Gateway');

var Web3 = require('web3');

var RivetGateway =
/*#__PURE__*/
function (_Gateway) {
  "use strict";

  _inherits(RivetGateway, _Gateway);

  function RivetGateway(key) {
    var _this;

    _classCallCheck(this, RivetGateway);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RivetGateway).call(this));
    _this.available = !!key;

    if (!key) {
      console.warn('Warning: RivetGateway created without API Key. Rivet will be unavailable.');
    }

    _this.providerStrings = {
      '1': "https://eth.rpc.rivet.cloud/".concat(key),
      '3': "https://ropsten.rpc.rivet.cloud/".concat(key),
      '4': "https://rinkeby.rpc.rivet.cloud/".concat(key),
      '5': "https://goerli.rpc.rivet.cloud/".concat(key)
    };
    _this.providers = {};
    return _this;
  }

  _createClass(RivetGateway, [{
    key: "isAvailable",
    value: function isAvailable() {
      return this.available;
    }
  }, {
    key: "getNetworks",
    value: function getNetworks() {
      return ['1', '3', '4', '5'];
    }
  }, {
    key: "_provider",
    value: function _provider(network) {
      if (!this.providers[network]) {
        if (!this.providerStrings[network]) {
          throw new Error("Network ".concat(network, " not supported by RivetGateway"));
        }

        this.providers[network] = new Web3.providers.HttpProvider(this.providerStrings[network]);
      }

      return this.providers[network];
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(network, _ref) {
        var method, params, id, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = _ref.method, params = _ref.params, id = _ref.id;

                if (!(this.getNetworks().indexOf(network) === -1)) {
                  _context.next = 3;
                  break;
                }

                throw new Error('Rivet does not support this network');

              case 3:
                _context.next = 5;
                return this._provider(network).send(method, params);

              case 5:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x, _x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }]);

  return RivetGateway;
}(Gateway);

module.exports = RivetGateway;